//@ts-ignore
import { formatFloatAsCurrencySymbol } from '../common/helpers.mjs'
//@ts-ignore
import { currencyObject } from '../common/types/types'
import useLocalization from '../hooks/useLocalization'

interface PayrollServicesProps {
   HasPayroll: boolean
   className: string
   currencyObject: currencyObject
}

export default function PayrollServices({
   HasPayroll,
   className,
   currencyObject,
}: PayrollServicesProps) {
   const host_url =
      process.env.REACT_APP_HOST_URL || 'https://quote.bamboohr.net'
   const { getString, getFormattedString, getTransformedString } =
      useLocalization(host_url)

   const transformPrice = (varName: string, value: string | number): string => {
      const trimmedVarName = varName.trim()
      const trimmedValue = typeof value === 'string' ? value.trim() : value
      return trimmedVarName === 'price'
         ? `${formatFloatAsCurrencySymbol(Number(trimmedValue) * currencyObject.Rate, currencyObject)}`
         : String(trimmedValue)
   }

   const FullAdditionalPayrollServicesList = getString(
      'pdf.payrollservices.fulladditionalserviceslist',
      'For a full list of additional payroll services offered, ',
   )
   const AdditionalPayrollServicesLinkText = getString(
      'pdf.payrollservices.additionalpayrollserviceslinktext',
      'click here',
   )

   const Garnishments = getString(
      'pdf.payrollservices.garnishments',
      'Collect & Remit Garnishments',
   )
   const GarnishmentsPrice = getTransformedString(
      'pdf.payrollservices.garnishmentsprice',
      transformPrice,
      '{price: 4} per garnishment per pay cycle',
   )

   const W2Forms = getString('pdf.payrollservices.w2forms', 'W-2 forms')
   const W2FormsPrice = getTransformedString(
      'pdf.payrollservices.w2formsprice',
      transformPrice,
      '{price: 7} per W-2 form',
   )

   const BaseService = getString(
      'pdf.payrollservices.baseservice',
      '1099 Base Service',
   )
   const BaseServicePrice = getTransformedString(
      'pdf.payrollservices.baseserviceprice',
      transformPrice,
      '{price: 25} Annually',
   )

   const PrintAndMail = getString(
      'pdf.payrollservices.printandmail',
      'Print & Mail 1099 forms (Note: All 1099 contractors will be mailed a 1099 form)',
   )
   const PrintAndMailPrice = getTransformedString(
      'pdf.payrollservices.printandmailprice',
      transformPrice,
      '{price: 12} per 1099 form printed and mailed',
   )

   const Research = getString(
      'pdf.payrollservices.research',
      'Research and/or Problem Solving',
   )
   const ResearchPrice = getTransformedString(
      'pdf.payrollservices.researchprice',
      transformPrice,
      '{price: 200} per hour, {price: 200} minimum',
   )

   const CustomGLReportMain = getString(
      'pdf.payrollservices.customglreport.main',
      'Custom General Ledger Report Creation',
   )
   const CustomGLReportNote = getString(
      'pdf.payrollservices.customglreport.note',
      '(Highly Complex requests will be charged $600)',
   )
   const CustomGLReportSuffix = getString(
      'pdf.payrollservices.customglreport.suffix',
      '****',
   )
   const CustomGLReportPrice = getTransformedString(
      'pdf.payrollservices.customglreportprice',
      transformPrice,
      '{price: 400}',
   )

   const CustomReportMain = getString(
      'pdf.payrollservices.customreport.main',
      '401k/HSA/FSA/Workers Comp Custom Report Creation',
   )
   const CustomReportSuffix = getString(
      'pdf.payrollservices.customreport.suffix',
      '****',
   )
   const CustomReportPrice = getTransformedString(
      'pdf.payrollservices.customreportprice',
      transformPrice,
      '{price: 300}',
   )

   const GLReportUpdates = getString(
      'pdf.payrollservices.glreportupdates',
      'Custom Report Updates',
   )
   const GLReportUpdatesPrice = getTransformedString(
      'pdf.payrollservices.glreportupdatesprice',
      transformPrice,
      '{price: 200}',
   )

   if (HasPayroll) {
      return (
         <div className={className}>
            <b className='productHeader'>
               {getString(
                  'pdf.payrollservices.sectionheader',
                  'Additional Payroll Services not included in this price quote:',
               )}
            </b>
            <br />
            <i>
               {FullAdditionalPayrollServicesList}{' '}
               <a href='https://www.bamboohr.com/additional-payroll-services/'>
                  {AdditionalPayrollServicesLinkText}
               </a>
            </i>
            <br />
            <table
               className='tableClass4'
               cellPadding='0'
               cellSpacing='0'
               style={{ marginTop: '1em' }}
            >
               <thead>
                  <tr>
                     <th colSpan={2} scope='colgroup'>
                        &nbsp;
                     </th>
                  </tr>
               </thead>
               <tfoot>
                  <tr>
                     <td colSpan={2}>&nbsp;</td>
                  </tr>
               </tfoot>
               <tbody>
                  <tr>
                     <td>{Garnishments}</td>
                     <td>{GarnishmentsPrice}</td>
                  </tr>
                  <tr>
                     <td>{W2Forms}</td>
                     <td>{W2FormsPrice}</td>
                  </tr>
                  <tr>
                     <td>{BaseService}</td>
                     <td>{BaseServicePrice}</td>
                  </tr>
                  <tr>
                     <td>{PrintAndMail}</td>
                     <td>{PrintAndMailPrice}</td>
                  </tr>
                  <tr>
                     <td>{Research}</td>
                     <td>{ResearchPrice}</td>
                  </tr>
                  <tr>
                     <td>
                        {CustomGLReportMain} <i>{CustomGLReportNote}</i>
                        {CustomGLReportSuffix}
                     </td>
                     <td>{CustomGLReportPrice}</td>
                  </tr>
                  <tr>
                     <td>
                        {CustomReportMain}
                        {CustomReportSuffix}
                     </td>
                     <td>{CustomReportPrice}</td>
                  </tr>
                  <tr>
                     <td>{GLReportUpdates}</td>
                     <td>{GLReportUpdatesPrice}</td>
                  </tr>
               </tbody>
            </table>
            <span>
               **** Please note that, upon delivery of a custom report, a 30-day
               warranty period is granted during which adjustments to the report
               will be made for no charge.
            </span>
         </div>
      )
   } else {
      return <></>
   }
}
